import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import css from 'styled-jsx/css';

const { className: modalClass, styles: modalStyles } = css.resolve`
  @media (max-width: 767px) {
    .modal-dialog {
      height: 100%;
      width: 100%;
      max-height: 100%;
      max-width: 100%;
      margin: 0;
    }
  }
`;

const { className: contentClass, styles: contentStyles } = css.resolve`
  @media (max-width: 767px) {
    .modal-content {
      height: 100%;
    }
  }
  @media (min-width: 768px) {
    .modal-content {
      border-radius: 1rem;
    }
  }
  @media (min-width: 992px) {
    .modal-content {
      max-width: 75%;
      margin: 0 auto;
    }
  }
`;

const { className: modalBodyClass, styles: modalBodyStyles } = css.resolve`
  .modal-body {
    padding: 0;
  }
`;

export default memo(ReminderMessagePreviewDisplay);

function ReminderMessagePreviewDisplay(props) {
  const { isOpen, toggleModal, instance, message: reminderMessage } = props;
  const message = reminderMessage
    .replace(/{{.AssetName}}/g, instance.gatewayName)
    .replace(/{{.OrgName}}/g, instance.orgName);
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      size="lg"
      centered
      className={modalClass}
      contentClassName={contentClass}
    >
      <ModalBody className={modalBodyClass}>
        <button
          className="btn btn-link position-absolute close-modal-x text-muted"
          onClick={toggleModal}
        >
          &#x2A09;
        </button>
        <div className="container-fluid message-modal-container">
          <div className="row title-container col-12">
            <h5 className="font-weight-bold mb-0">
              {instance.reminder.name}
              <span className="text-icon-link-gray nine-tenth-text font-weight-normal ml-2">
                {instance.gatewayName}
              </span>
            </h5>
          </div>
          <div className="row col-12 text-left form-group">
            <textarea
              className="text-area w-100"
              rows="6"
              style={{ resize: 'none' }}
              value={message}
              name="message"
              readOnly
            />
          </div>
          <div className="row justify-content-end button-conatiner align-items-center align-items-md-end col-12">
            <div className="col-3 col-md-3 col-lg-2 pl-0">
              <button
                className="btn btn-outline-secondary py-0 px-4"
                onClick={toggleModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
      {modalStyles}
      {contentStyles}
      {modalBodyStyles}
      <style jsx>{`
        .btn {
          font-size: 0.9rem;
        }
        .text-area {
          border: none;
          outline: none;
          border-color: RGBA(104, 104, 104, 0.34);
        }
        .message-modal-container {
          display: grid;
          grid-template-rows: 3rem calc(100% - 6rem) 3rem;
          padding: 1rem;
          height: 100%;
        }
        @media (min-width: 768px) {
          .message-modal-container {
            padding: 2rem;
            height: 20rem;
          }
        }
      `}</style>
    </Modal>
  );
}

ReminderMessagePreviewDisplay.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  instance: PropTypes.object,
  message: PropTypes.string,
};

ReminderMessagePreviewDisplay.defaultProps = {
  message: '',
  instance: { reminder: {} },
};
